/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Drawer {
    angular.module("meevo.plugins.drawer", []);
}